module.exports = __webpack_public_path__ + "img/announcement-img-default.8ede4ae3.png";